export type WeekDay = 'short' | 'long' | 'narrow' | undefined
export type Month = 'short' | 'long' | 'narrow' | '2-digit' | 'numeric'
export type Day = '2-digit' | 'numeric'
export type Year = '2-digit' | 'numeric'

const dateFR: DateOptions = { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', language: 'fr-FR' }
const dateEN: DateOptions = { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', language: 'en-EN' }


export interface DateOptions {
    weekday:WeekDay,
    day:Day,
    month:Month,
    year:Year,
    language:string
}

export const DateOptionSet = {
    dateFR,
    dateEN
}
